import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { HeartbeatService } from '../../../services/heartbeat.service';

@Component({
  selector: 'user-status',
  
  imports: [],
  template: `
    <!-- <div class="status-indicator" [class.online]="isOnline" [class.offline]="!isOnline">
      <div class="status-dot"></div>
      <span>{{ statusText }}</span>
    </div>
    
    <div class="status-details">
      <p>Server: {{ serverConnected ? 'Connected' : 'Disconnected' }}</p>
      <p>Page: {{ pageVisible ? 'Visible' : 'Hidden' }}</p>
    </div> -->
  `,
  styles: [`
    .status-indicator {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px;
      border-radius: 8px;
      font-weight: 500;
      transition: all 0.3s ease;
    }
    
    .status-indicator.online {
      background-color: #d4edda;
      color: #155724;
    }
    
    .status-indicator.offline {
      background-color: #f8d7da;
      color: #721c24;
    }
    
    .status-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transition: background-color 0.3s ease;
    }
    
    .online .status-dot {
      background-color: #28a745;
    }
    
    .offline .status-dot {
      background-color: #dc3545;
    }
    
    .status-details {
      margin-top: 16px;
      padding: 12px;
      background-color: #f8f9fa;
      border-radius: 8px;
    }
    
    .status-details p {
      margin: 4px 0;
      font-size: 14px;
    }
  `]
})
export class UserStatusComponent implements OnInit, OnDestroy {
  isOnline = true;
  serverConnected = true;
  pageVisible = true;
  statusText = 'Online';

  private subscription?: Subscription;

  constructor(private heartbeatService: HeartbeatService) { }

  ngOnInit() {
    // Start heartbeat monitoring
    this.heartbeatService.startHeartbeat();

    // Subscribe to status changes
    this.subscription = this.heartbeatService.onlineStatus$.subscribe(serverConnected => {
      this.serverConnected = serverConnected;
      this.updateStatus();
    });

    // Subscribe to visibility changes
    this.heartbeatService.isVisible$.subscribe(visible => {
      this.pageVisible = visible;
      this.updateStatus();
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.heartbeatService.stopHeartbeat();
  }

  private updateStatus() {
    this.isOnline = this.serverConnected && this.pageVisible;

    if (!this.serverConnected) {
      this.statusText = 'Server Connection Lost';
    } else if (!this.pageVisible) {
      this.statusText = 'Away';
    } else {
      this.statusText = 'Online';
    }
  }
}